import React from 'react';
import { get } from 'lodash';

class ListItemKetQuaKiemTraChiTiet extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {};
  }

  renderData(arrayKey) {
    return arrayKey.map((item, i) => (
      <tr key={i}>
        <td>{i + 1}</td>
        <td>{item.tenDoanhNghiep}</td>
        <td>{item.noiDung}</td>
        <td>{item.thoiHan}</td>
        <td>{item.tomTatViPham}</td>
        <td>{item.tongTienViPham}</td>
        <td>{item.tienKienNghiThuHoi}</td>
        <td>{item.kienNghiXuLyKhac}</td>
        <td>{item.soToChucViPhamHanhChinh}</td>
        <td>{item.soCaNhanViPhamHanhChinh}</td>
        <td>{item.tongTienViPhamHanhChinh}</td>
        <td>{item.ketQuaThucHien}</td>
        <td>{item.soVuChuyenCoQuanDieuTra}</td>
        <td>{item.soDoiTuongChuyenCoQuanDieuTra}</td>
      </tr>
    ));
  }

  renderTheoKeHoach() {
    return (
      <span style={{ display: 'contents' }}>
        <tr>
          <td style={{ color: '#0077EE', fontWeight: '700' }}>A</td>
          <td
            style={{ color: '#0077EE', fontWeight: '700' }}
            colSpan={this.props.totalCol - 1}
          >
            Theo kế hoạch
          </td>
        </tr>
        <tr>
          <td style={{ fontWeight: 'bold' }}>I</td>
          <td style={{ fontWeight: 'bold' }} colSpan={this.props.totalCol - 1}>
            Doanh nghiệp được thanh tra theo kế hoạch
          </td>
        </tr>
        {this.renderData(get(this.props.dataList, 'thanhTraTheoKeHoach', []))}
        <tr>
          <td style={{ fontWeight: 'bold' }}>II</td>
          <td style={{ fontWeight: 'bold' }} colSpan={this.props.totalCol - 1}>
            Doanh nghiệp được kiểm tra theo kế hoạch
          </td>
        </tr>
        {this.renderData(get(this.props.dataList, 'kiemTraTheoKeHoach', []))}
      </span>
    );
  }

  renderDotXuat() {
    return (
      <span style={{ display: 'contents' }}>
        <tr>
          <td style={{ color: '#0077EE', fontWeight: '700' }}>B</td>
          <td
            style={{ color: '#0077EE', fontWeight: '700' }}
            colSpan={this.props.totalCol - 1}
          >
            Đột xuất
          </td>
        </tr>
        <tr>
          <td style={{ fontWeight: 'bold' }}>I</td>
          <td style={{ fontWeight: 'bold' }} colSpan={this.props.totalCol - 1}>
            Doanh nghiệp được thanh tra đột xuất
          </td>
        </tr>
        {this.renderData(get(this.props.dataList, 'thanhTraDotXuat', []))}
        <tr>
          <td style={{ fontWeight: 'bold' }}>II</td>
          <td style={{ fontWeight: 'bold' }} colSpan={this.props.totalCol - 1}>
            Doanh nghiệp được kiểm tra đột xuất
          </td>
        </tr>
        {this.renderData(get(this.props.dataList, 'kiemTraDotXuat', []))}
      </span>
    );
  }

  render() {
    return (
      <span style={{ display: 'contents' }}>
        {this.renderTheoKeHoach()}
        {this.renderDotXuat()}
      </span>
    );
  }
}

export default ListItemKetQuaKiemTraChiTiet;



// WEBPACK FOOTER //
// ./src/components/modules/thong-ke-bao-cao/datatable/ListItemKetQuaKiemTraChiTiet.jsx